const setupCommaRemoval = function() {
  const numericInputs = [
    '#part_unit_price',
    '#part_quantity',
    '#part_markup_rate',
    '#part_selling_price_total',
    '#part_discount',
    '#part_discount_amount',
    '#part_total_price'
  ];

  // Track if this is initial page load
  let isInitialLoad = true;

  // Clean existing values on load without warning
  numericInputs.forEach(selector => {
    const element = $(selector)[0];
    if (element && element.value.includes(',')) {
      const originalValue = element.value;
      element.value = element.value.replace(/,/g, '');

      // Trigger calculation if value changed during load
      if (originalValue !== element.value) {
        $(element).trigger('focusout');
      }
    }
  });

  // After a short delay, mark initial load as complete
  setTimeout(() => {
    isInitialLoad = false;
  }, 100);

  numericInputs.forEach(selector => {
    $(selector).on('input', function(e) {
      const value = e.target.value;
      const cleanValue = value.replace(/,/g, '');

      // Only update if we actually removed commas
      if (value !== cleanValue) {
        // Store cursor position
        const cursorPos = e.target.selectionStart;
        const commasBeforeCursor = (value.substring(0, cursorPos).match(/,/g) || []).length;

        // Update value
        e.target.value = cleanValue;

        // Restore cursor position accounting for removed commas
        const newCursorPos = cursorPos - commasBeforeCursor;
        e.target.setSelectionRange(newCursorPos, newCursorPos);

        // Show warning only if not initial load
        if (!isInitialLoad && toastr) {
          toastr.warning('Commas have been removed from the number field', 'Input Cleaned');
        }

        // Trigger calculation after comma removal
        $(e.target).trigger('focusout');
      }
    });
  });
};

const parseNumericValue = function(value) {
  if (typeof value !== 'string') {
    return parseFloat(value);
  }

  if (value.trim() === '') {
    return NaN;
  }

  // Remove commas before parsing - defense in depth
  const cleanValue = value.replace(/,/g, '');
  return parseFloat(cleanValue);
}

const calculateMarkup = function(unitPrice, totalWithMarkup, quantity = 1) {
  const total = unitPrice * quantity;
  if (total === 0) return 0;
  return ((totalWithMarkup - total) / total) * 100.0;
}

const calculateTotalWithMarkup = function(unitPrice, quantity, markupRate) {
  const total = unitPrice * quantity;
  return total + ((markupRate * total) / 100.0);
}

const calculateDiscountAmount = function(total, discountPercent) {
  return (total * (discountPercent / 100.0));
}

// Original helper functions - unchanged
const checkValidNumber = function(input) {
  const value = parseNumericValue(input.value) // NOW USES parseNumericValue!
  if (isNaN(value) || !isFinite(value)) {
    input.setCustomValidity("Please enter a valid number.")
  } else {
    input.setCustomValidity("")
  }
}

const checkValidMarkupRate = function(markup_rate) {
  const input = $('#part_markup_rate')[0]
  if (markup_rate < 0) {
    input.setCustomValidity("Markup rate cannot be negative.")
  } else {
    input.setCustomValidity("")
  }
}

const setupToFixedDown = function() {
  Number.prototype.toFixedDown = function(digits) {
    const re = new RegExp('(\\d+\\.\\d{' + digits + '})(\\d)');
    const m = this.toString().match(re);
    return m ? parseFloat(m[1]) : this.valueOf();
  }
}

setupToFixedDown();


const setOrClear = function(selector, value, digits = 2) {
  if (isNaN(value)) {
    $(selector).val('')
  } else {
    $(selector).val(value.toFixedDown(digits).toFixed(digits))
  }
}

const partsCalculator = function() {
  $("#part_selling_price_total").on("input focusout", function() {
    const selling_price_total = parseNumericValue($(this).val())
    const unit_price = parseNumericValue($("#part_unit_price").val())
    const quantity = parseInt($("#part_quantity").val()) || 1

    let markup_rate = calculateMarkup(unit_price, selling_price_total, quantity)

    if (isNaN(markup_rate)) {
      $('#part_markup_rate').val('')
      return
    }

    markup_rate = parseFloat(markup_rate.toFixed(7))
    let precision = 7

    // Keep original precision logic - it's complex and works
    while ((unit_price * quantity * (1 + markup_rate / 100.0)) !== selling_price_total) {
      precision--
      markup_rate = parseFloat(markup_rate.toFixed(precision))

      if ((unit_price * quantity * (1 + markup_rate / 100.0)) !== selling_price_total) {
        const markup_rate_ceiling = parseFloat(
          (markup_rate + (5 / Math.pow(10, precision))).toFixed(precision)
        )
        if ((unit_price * quantity * (1 + markup_rate_ceiling / 100.0)) !== selling_price_total) {
          setOrClear('#part_markup_rate', markup_rate_ceiling, precision)
          return
        }
      } else {
        setOrClear('#part_markup_rate', markup_rate, precision)
        return
      }

      if (precision === 0) {
        $('#part_markup_rate').val('')
        return
      }
    }

    setOrClear('#part_markup_rate', markup_rate, precision)
    checkValidMarkupRate(markup_rate)
  })

  $("#part_markup_rate").on("input focusout", function() {
    const markup_rate = parseNumericValue($(this).val())
    checkValidNumber(this)

    const unit_price = parseNumericValue($("#part_unit_price").val())
    const quantity = parseInt($("#part_quantity").val()) || 1

    const selling_price_total = calculateTotalWithMarkup(unit_price, quantity, markup_rate)

    setOrClear('#part_selling_price_total', selling_price_total)
    discountCalculation(selling_price_total)
    checkValidMarkupRate(markup_rate)
  })

  $("#part_quantity").on("input focusout", function() {
    const unit_price = parseNumericValue($("#part_unit_price").val())
    const quantity = parseInt($(this).val()) || 1
    const markup_rate = parseNumericValue($("#part_markup_rate").val())

    checkValidNumber($("#part_markup_rate")[0])

    // Use the testable function
    const selling_price_total = calculateTotalWithMarkup(unit_price, quantity, markup_rate)

    setOrClear('#part_selling_price_total', selling_price_total)
    discountCalculation(selling_price_total)
    checkValidMarkupRate(markup_rate)
  })

  $("#part_unit_price").on("input focusout", function() {
    const unit_price = parseNumericValue($(this).val())
    const quantity = parseInt($("#part_quantity").val()) || 1
    const markup_rate = parseNumericValue($("#part_markup_rate").val())

    checkValidNumber($("#part_markup_rate")[0])

    // Use the testable function
    const selling_price_total = calculateTotalWithMarkup(unit_price, quantity, markup_rate)

    setOrClear('#part_selling_price_total', selling_price_total)
    discountCalculation(selling_price_total)
    checkValidMarkupRate(markup_rate)
  })

  $("#part_discount").on("input focusout", function() {
    const unit_price = parseNumericValue($("#part_unit_price").val())
    const quantity = parseInt($("#part_quantity").val()) || 1
    const markup_rate = parseNumericValue($("#part_markup_rate").val())

    // Use the testable function
    const selling_price_total = calculateTotalWithMarkup(unit_price, quantity, markup_rate)

    checkValidNumber($("#part_markup_rate")[0])
    setOrClear('#part_selling_price_total', selling_price_total)
    discountCalculation(selling_price_total)
    checkValidMarkupRate(markup_rate)
  })

  $("#part_discount_amount").on("input focusout", function() {
    const unit_price = parseNumericValue($("#part_unit_price").val())
    const quantity = parseInt($("#part_quantity").val()) || 1
    const markup_rate = parseNumericValue($("#part_markup_rate").val())

    const selling_price_total = calculateTotalWithMarkup(unit_price, quantity, markup_rate)

    checkValidNumber($("#part_markup_rate")[0])
    setOrClear('#part_selling_price_total', selling_price_total)

    const discount_amount = parseNumericValue($(this).val())
    let discount = parseFloat((discount_amount / selling_price_total) * 100.0)
    setOrClear('#part_discount_amount', discount_amount)

    const total_price = selling_price_total - discount_amount
    setOrClear('#part_total_price', total_price)

    discount = parseFloat(discount.toFixed(7))
    let precision = 7

    // Keep original precision logic
    while ((selling_price_total * (discount / 100.0)) !== discount_amount) {
      precision--
      discount = parseFloat(discount.toFixed(precision))

      if ((selling_price_total * (discount / 100.0)) !== discount_amount) {
        const discount_ceiling = parseFloat(
          (discount + (5 / Math.pow(10, precision))).toFixed(precision)
        )
        if ((selling_price_total * (discount_ceiling / 100.0)) !== discount_amount) {
          setOrClear('#part_discount', discount_ceiling, precision)
          return
        }
      } else {
        setOrClear('#part_discount', discount, precision)
        return
      }

      if (precision === 0) {
        $('#part_discount').val('')
        return
      }
    }

    setOrClear('#part_discount', discount, precision)
    checkValidMarkupRate(markup_rate)
  })
}

const discountCalculation = function(selling_price_total) {
  const discount = parseNumericValue($("#part_discount").val()) || 0.0
  const discount_amount = calculateDiscountAmount(selling_price_total, discount)
  setOrClear('#part_discount_amount', discount_amount)
  const final_price = selling_price_total - discount_amount
  setOrClear('#part_total_price', final_price)
}

$(document).ready(function() {
  partsCalculator()
  setupCommaRemoval()
})
$(document).on('turbolink:load', partsCalculator)

// Export for testing
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    calculateMarkup,
    calculateTotalWithMarkup,
    calculateDiscountAmount,
    parseNumericValue,
    setOrClear,
    setupCommaRemoval,
    setupToFixedDown
  };
}
